var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOffergift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-offer_gift",
    "data-name": "icon-offer gift",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7159",
    "data-name": "Rectangle 7159",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gift-hand-present-icon",
    transform: "translate(0.983 2.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    d: "M0,10H4.452v7.921H0V10ZM15,2.912a8.241,8.241,0,0,1,.848-1.533c.662-.909,2.281-2,3.27-.943.886.947.134,1.983-.92,2.476h2.388a.665.665,0,0,1,.477.2.674.674,0,0,1,.2.477V4.877a.684.684,0,0,1-.624.674v6.058a1.463,1.463,0,0,1,.873,2.585A45.074,45.074,0,0,1,13.848,18.7a5.187,5.187,0,0,1-5.694,0l-2.8-1.445V10.639H8.328a6.038,6.038,0,0,1,.731.179V5.554a.692.692,0,0,1-.439-.2.674.674,0,0,1-.2-.477V3.593a.665.665,0,0,1,.2-.477.674.674,0,0,1,.477-.2h2.431c-1.051-.493-1.8-1.529-.92-2.476.99-1.063,2.607.034,3.27.943a8.478,8.478,0,0,1,.848,1.533h.265l0,0Zm3.118,9.649H15.1a.9.9,0,0,1-.1,1.6,4.278,4.278,0,0,1-2.978.463.5.5,0,1,0,0,.982c.274.022.572-.043.832-.043,1.37,0,2.5-.264,3.186-1.345l.346-.809,1.725-.853ZM9.619,11.017a13.315,13.315,0,0,1,1.924.977h2.424V9.517H9.619v1.5Zm9.637.977.576-.285c.082-.027.165-.048.246-.066V9.517H15.784v2.478Zm-2.1-9.083c2.415-1.07,1.614-2.874.084-2a3.266,3.266,0,0,0-.929.966,11.75,11.75,0,0,0-.651,1.036Zm-4.592,0c-2.415-1.07-1.614-2.874-.084-2a3.266,3.266,0,0,1,.929.966,11.75,11.75,0,0,1,.651,1.036Zm-2.946,5.1h4.348V5.284H9.619V8.011Zm6.162,0h4.287V5.284H15.781V8.011Z",
    transform: "translate(0 0)",
    fill: "#02466a",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOffergift);
export default __webpack_public_path__ + "static/media/icon-offer gift.c29e1771314f43895ce16297cc09ace9.svg";
export { ForwardRef as ReactComponent };